import { persist } from 'zustand/middleware';
import { createWithEqualityFn } from 'zustand/traditional';
import { SystemAlertGetResponse } from '@lio/api-types';

type AlertStore = {
  dismissedIds: string[];
  headerHeight: number;
  activeAlerts: SystemAlertGetResponse[];
  dismissAlert: (id: string) => void;
  updateHeight: (newHeight: number) => void;
  isPaymentDisabled: boolean;
};

export const useAlertStore = createWithEqualityFn<AlertStore>()(
  persist(
    (set) => ({
      dismissedIds: [],
      headerHeight: 0,
      activeAlerts: [],
      isPaymentDisabled: false,
      dismissAlert: (id: string) => set((state) => ({ dismissedIds: state.dismissedIds.concat(id) })),
      updateHeight: (newHeight: number) => set(() => ({ headerHeight: newHeight })),
    }),
    {
      name: 'lio-alert-storage',
    },
  ),
);
